import tools from "../../../helpers/tools";

const RecipientInfoHeader = ({
  recipient,
  age,
  sddStatus,
  maritalStatus,
  rsaType,
}) => {
  return (
    <div
      className="p-3 rounded mb-3"
      style={{
        background: "#f8f9fa",
        borderLeft: "4px solid #007bff",
      }}
    >
      <strong>{tools.getFullname(recipient)}</strong>
      <br />
      <div className="d-flex flex-column">
        <span>
          NIR : <strong>{recipient.nir}</strong>
        </span>
        <span>
          Âge : <strong>{age} ans</strong>
        </span>
        <span>
          Statut : <strong>{sddStatus}</strong>
        </span>
        <span>
          Situation familiale: <strong>{maritalStatus}</strong>
        </span>
        <span>
          Type de RSA: <strong>{rsaType}</strong>
        </span>
      </div>
    </div>
  );
};

export default RecipientInfoHeader;
